const ANON_COOKIE_KEY = 'orion_anon_id';
const SESSION_COOKIE_KEY = 'orion_session_id';
const CONSENT_COOKIE_KEY = 'orion_consent_state';
const SESSION_LAST_SEEN_KEY = 'orion_session_last_seen';
const SESSION_IDLE_WINDOW_MS = 30 * 60 * 1000;

function readCookie(name) {
  const key = `${name}=`;
  const cookies = document.cookie ? document.cookie.split(';') : [];

  for (const cookie of cookies) {
    const value = cookie.trim();
    if (value.startsWith(key)) {
      return decodeURIComponent(value.slice(key.length));
    }
  }

  return null;
}

function writeCookie(name, value, maxAgeSeconds) {
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax`;
}

function buildId(prefix) {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}_${crypto.randomUUID()}`;
  }

  return `${prefix}_${Math.random().toString(36).slice(2)}_${Date.now()}`;
}

export function ensureAnalyticsSession() {
  if (typeof document === 'undefined') {
    return null;
  }

  let anonId = readCookie(ANON_COOKIE_KEY);
  if (!anonId) {
    anonId = buildId('anon');
    writeCookie(ANON_COOKIE_KEY, anonId, 60 * 60 * 24 * 365);
  }

  const now = Date.now();
  const lastSeenRaw = Number(readCookie(SESSION_LAST_SEEN_KEY) || 0);
  const isSessionExpired = !lastSeenRaw || now - lastSeenRaw > SESSION_IDLE_WINDOW_MS;

  let sessionId = readCookie(SESSION_COOKIE_KEY);
  if (!sessionId || isSessionExpired) {
    sessionId = buildId('sess');
  }

  writeCookie(SESSION_COOKIE_KEY, sessionId, 60 * 60 * 24);
  writeCookie(SESSION_LAST_SEEN_KEY, String(now), 60 * 60 * 24);

  const consentState = readCookie(CONSENT_COOKIE_KEY) || 'unknown';

  return {
    anonId,
    sessionId,
    consentState,
  };
}

export function getAnalyticsHeaders() {
  const session = ensureAnalyticsSession();
  if (!session) {
    return {};
  }

  return {
    'x-anon-id': session.anonId,
    'x-session-id': session.sessionId,
    'x-consent-state': session.consentState,
  };
}
